import React, { useState, useContext } from 'react';
import { getProductMetadata } from '../../network/ApiService';
import './GenerateAccessCode.scss';
import { AppContext } from '../../App';
import './StepOneComponent.scss';
const StepOneComponent = ({ setStep, isOpen, setLoading,onError }) => {

    const {
        isbn,
        setIsbn,
        ppdNumber,
        setPpdNumber,
        ppidTitle, 
        setPpidTitle
    } = useContext(AppContext);
    const [PPIDTitle, setPPIDTitle] = useState('');
    const [isValidISBN, setIsValidISBN] = useState(false);
    const [isInvalidISBN, setIsInvalidISBN] = useState(false);
    const [isLoadingISBN, setIsLoadingISBN] = useState(false);
    const [inputIdValue, setInputIdValue] = useState('');

    if (!isOpen) return null;

    const handleISBNChange = (e) => {
        setInputIdValue(e.target.value);
        setIsInvalidISBN(false);
        setIsValidISBN(false);
    }

    const handleCheckISBN = async () => {
        if (inputIdValue.length === 13 ) {
            setIsLoadingISBN(true);
            setIsInvalidISBN(false);
            setLoading(true);
            const subscription = getProductMetadata(inputIdValue).subscribe(
                (response) => {
                    if (response) {
                        setPPIDTitle(response[0]?.resourceTitle || '');
                        setPpdNumber(response[0]?.productId || '');
                        setPpidTitle(response[0]?.resourceTitle || '');
                        setIsbn(response[0]?.isbn || '');
                        setIsValidISBN(true);
                        setIsInvalidISBN(false);
                    } else {
                        setIsValidISBN(false);
                        setIsInvalidISBN(true);
                    }
                    setIsLoadingISBN(false);
                    setLoading(false);
                },
                (error) => {
                    console.error('Error fetching product metadata:', error);
                    setIsValidISBN(false);
                    setIsInvalidISBN(true);
                    setIsLoadingISBN(false);
                    setLoading(false);
                    onError(error);
                }
            );
            return () => subscription.unsubscribe();
        } else {
            setIsValidISBN(false);
            setIsInvalidISBN(true);
            setLoading(false);
        }
    };

    const shouldDisablePPIDFields = !isValidISBN;
    return (
        <div className='step-one-component'>
            <div className="isbn-section">
                <h3 className="isbn-title">Enter ISBN13 or PPID</h3>

                <div className='isbn-input-section'>
                    <div>
                        <h5 className="isbn-subtitle">Enter ISBN13 or PPID</h5>
                        <p className="isbn-instruction">
                            Enter the ISBN or PPID that you want to generate codes for.
                        </p>
                        {isValidISBN &&
                            <div className="isbn-valid">
                                <img className="isbn-valid-icon" src={`${process.env.PUBLIC_URL}/images/success-new.svg`} alt="Valid" />
                                <span>This is a valid ISBN or PPID</span>
                            </div>}
                        {isInvalidISBN &&
                            <div className="isbn-invalid">
                                <img className="isbn-invalid-icon" src={`${process.env.PUBLIC_URL}/images/error-new.svg`} alt="Invalid" />
                                <span>This ISBN or PPID is not recognised. Please re-type and check ISBN or PPID again.</span>
                            </div>}

                    </div>
                    <div className="isbn-input-container">
                        <input
                            type="text"
                            placeholder="Enter ISBN or PPID"
                            maxLength={13}
                            className={`isbn-input ${isValidISBN && 'valid-isbn-input'} ${isInvalidISBN && 'invalid-isbn-input'}`}
                            value={inputIdValue}
                            onChange={handleISBNChange}
                        />
                        {isInvalidISBN &&
                            <button className="clearIsbn" onClick={() => setInputIdValue("")}>
                                <img src={`${process.env.PUBLIC_URL}/images/close.svg`} alt="close" />
                            </button>
                        }
                    </div>
                </div>
                <button
                    className={`check-isbn-btn ${PPIDTitle? 'check-white-btn' : 'check-btn'}`}
                    onClick={handleCheckISBN}
                    disabled={isLoadingISBN}
                >
                    <span>{isLoadingISBN ? 'Checking...' : 'Check ISBN13 or PPID'}</span>
                    <span className="refresh-icon">
                        <img src={`${process.env.PUBLIC_URL}/images/${PPIDTitle ? 'refresh-purple' : 'refresh-light'}.svg`} alt="Refresh" />
                    </span>
                </button>

            </div>

            {PPIDTitle && (
                <div className="details-section">
                    <div className="ppid-table">
                        <div className="ppid-row">
                            <label className="ppid-label">PPID Title</label>
                            <div className={`ppid-input ${shouldDisablePPIDFields ? 'disabled-input' : ''}`}>
                                <input
                                    type="text"
                                    value={shouldDisablePPIDFields ? 'PPID title will display here' : PPIDTitle}
                                    onChange={(e) => setPPIDTitle(e.target.value)}
                                    style={{ background: 'none' }}
                                    disabled={shouldDisablePPIDFields}
                                    readOnly
                                />
                                {isValidISBN && <img className="correct-icon" src={`${process.env.PUBLIC_URL}/images/correct-black.svg`} alt="correct" />}
                            </div>
                        </div>

                        <div className="ppid-row">
                            <label className="ppid-label">PPID Number</label>
                            <div className={`ppid-input ${shouldDisablePPIDFields ? 'disabled-input' : ''}`}>
                                <input
                                    type="text"
                                    value={shouldDisablePPIDFields ? 'PPID number will display here' : ppdNumber}
                                    onChange={(e) => setPpdNumber(e.target.value)}
                                    style={{ background: 'none', width: '93%' }}
                                    disabled={shouldDisablePPIDFields}
                                    readOnly
                                />
                                {isValidISBN && <img className="correct-icon" src={`${process.env.PUBLIC_URL}/images/correct-black.svg`} alt="correct" />}
                            </div>
                        </div>
                    </div>

                    <button
                        className={`continue-btn ${shouldDisablePPIDFields ? 'disabled-input' : ''}`}
                        disabled={shouldDisablePPIDFields}
                        onClick={() => setStep(2)}
                    >
                        <span>Continue with this ISBN13 or PPID</span>
                        <img src={`${process.env.PUBLIC_URL}/images/arrow-right.svg`} alt="arrow right" />
                    </button>
                </div>
            )}
        </div>
    )
}
export default StepOneComponent